export const CAPSULES_TABLE_PAGE_SIZE = 20;
